import { render } from "./Button.vue?vue&type=template&id=64beee6c&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=64beee6c&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64beee6c"]])

export default __exports__